import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendLowBudgetMail } from 'store/actions/auth.action';
import { LOCATION_NOT_SUPPORT, LOW_BUDGET_WINDOW, PASSWORD_SENT_ALERT, SHOW_BAD_LEAD, SHOW_PAYMENT_FAILED, SHOW_PROMO_CODE, SHOW_REMODEL_ALERT } from 'store/actions/types';
import { RootState } from 'store/reducers';
import store from 'store/store';
import { capitalizeFirstLetter, docIds, focusInput, getLocalStorageValue, history, localStorageKeyValue } from 'utils/handler';
import { AgentDetails } from 'views/types/agentDetailsQuestions';
import Payment from './Payment';

const PopupWindow = (props: any): JSX.Element => {
  return (
    <div className="popup-password-window" >
      <div className={"popup-content card " + (props.className)}>
        <div className="fs-21 f-bold saw-popup-header">
          <div className="close text-danger " onClick={() => props.onClose()}>
            <i className="fa fa-times fa-xl fa-custom-rotate-z"></i>
          </div>
          {props.header && <div className="heading">{props.header} </div>}
        </div>
        <div className="card-body popup-body ">{props.children}</div>
      </div>
    </div>
  );
};

export const NotSupportedLocationWindow = () => {
  const dispatch = useDispatch();
  const { registrarDetails } = useSelector((state: RootState) => state.userReducer);

  const closePopup = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else if (registrarDetails && registrarDetails.website) {
      let website = registrarDetails.website;
      if (!website.includes('http')) {
        website = 'http://' + registrarDetails.website;
      }
      window.open(website, '_self');
    }
    dispatch({ type: LOCATION_NOT_SUPPORT, payload: false });
  };

  return (
    <PopupWindow onClose={closePopup}>
      <div className="w-550 text-center ">
        <div className="title mt--35">
          <span>We Can’t Help You Right Now…</span>
        </div>
        <div className="">Thanks for visiting Saw.com - the brokerage firm that’s changing the domain game. Unfortunately, we don’t currently support your area with our service. Sorry! Please call or text +1-781-281-9475 with questions.</div>
        <div className="theme-color mt-4 fs-20 c-pointer" onClick={closePopup}>
          Close
        </div>
      </div>
    </PopupWindow>
  );
};

export default PopupWindow;

export const AppraisalPayment = () => {
  const dispatch = useDispatch();
  const closePopup = () => {
    dispatch({ type: LOCATION_NOT_SUPPORT, payload: false });
  };

  const paymentSuccess = (data: { consultant: AgentDetails }) => {
    // console.log(data, '####');
  };
  return (
    <div className="custom-popup-window ">
      <div className={'card popup-card lr10'}>
        <div className="d-flex justify-content-end" onClick={closePopup}>
          <i className="fas fa-times mr-1 fa-2x f-bold fa-custom-rotate-z"></i>
        </div>
        <div className="card-body ">
          <div className="w-550 ">
            <div className=" mt--35 text-center">
              <span className="title">Upgrade Your Saw.com Account To Access This Feature</span>
              <p>Sorry - but the Saw.com Dashboard is only for our paid account holders. It’s super easy to get involved, though! If you’re interested in enhancing your domain experience, you can get ALL of these for a one-time fee of just $19.95:</p>
            </div>
            <ul className="">
              <li>20 daily appraisal searches with additional information on each domain</li>
              <li>Your own dedicated domain consultant to assist with up to 5 acquisitions</li>
              <li>‘Guide To Purchasing a Domain’ eBook by Saw.com CEO Jeffrey Gabriel</li>
            </ul>
            <Payment paymentSuccess={paymentSuccess} />
          </div>
        </div>
      </div>
    </div>
  );
};
// let obj = {
//   UID: 'b7e9d2e9-2d7c-45f5-9a1c-b417802f9585',
//   image: 'files/NameSilo_Logo-24_11_2022 08_14_36.812.svg',
//   name: 'namesilo dev',
// };
export const PasswordAlert = () => {
  // const [showPromoCode, setShowPromoCode] = useState(false)

  const { registrarDetails, } = useSelector((state: RootState) => state.userReducer);
  const { showPromoAlert, badLeadAlert, passwordAlertBox, paymentFailedAlert } = useSelector((state: RootState) => state.mainReducer);
  // useEffect(() => {
  //     console.log('registrarDetails', showPromoAlert, myProfile, registrarDetails)
  //     if (!registrarDetails || _.isEmpty(registrarDetails)) {
  //         setShowPromoCode(true)
  //     }
  //     // if (!_.isEmpty(myProfile) && !myProfile.registrarUID) {
  //     //     setShowPromoCode(true)
  //     // } else {
  //     //     setShowPromoCode(false)
  //     // }
  // }, [registrarDetails, myProfile])

  const closeAlert = () => {
    store.dispatch({ type: PASSWORD_SENT_ALERT, payload: false });
    store.dispatch({ type: SHOW_PROMO_CODE, payload: false });
    store.dispatch({ type: SHOW_BAD_LEAD, payload: false });
    store.dispatch({ type: SHOW_PAYMENT_FAILED, payload: false });
  };
  // if (!myProfile?.registrarUID && myProfile?.userInterested === userInterested.buy) {
  //   this.setState({showOnlyPromo: true});
  // }
  const getAlertMessage = () => {
    if(badLeadAlert) return "Thanks for your interest in Saw.com! We’ve received your inquiry and will be in touch soon."
    if(paymentFailedAlert) return "Your payment was unsuccessful or still processing. Please try again after a few seconds."
    const currentEmail = localStorage.getItem("userEmail") || ""
    let message = '';
    if (passwordAlertBox) {
      message = ' a temporary password';
    }
    if ((!registrarDetails || _.isEmpty(registrarDetails)) && showPromoAlert) {
      message = message + (message ? ' and ' : ' ') + 'your welcome email';
    }
    return `Please check ${currentEmail || "your registered email"} for${message}`;
  };
  return (
    <PopupWindow onClose={closeAlert} header="Alert">
      <div className="model p-3">
        <div className="content form-group text-center">
          {getAlertMessage()}.{/* this needs to be used for future access */}
        </div>
        <footer className="row justify-content-center">
          <button className="btn btn-grad" onClick={closeAlert}>
            Okay!
          </button>
        </footer>
      </div>
    </PopupWindow>
  );
};


export const LowBudgetAlert = () => {
  const navigationType = {
    close: "Close",
    alternate: "Alternate",
    IncreaseDomain: "IncreaseDomain"
  }
  const { lowBudgetWindow } = useSelector((state: RootState) => state.leadReducer);
  const { registrarDetails } = useSelector((state: RootState) => state.userReducer);
  const [domainName, setDomainName] = useState(lowBudgetWindow.domainName || getLocalStorageValue(localStorageKeyValue.domainName))

  //   This is a low budget buyer that made a budget of _____ in the lead form.
  // Then every new budget they submit put it in the note as well.
  // This is a low budget buyer that made a budget of ____ in the lead form.
  // If they decide to go back to the registrar put a note in the lead that says:
  // User decided to go back to the registrar where he came from.

  const getLeadNote = (actionType: string) => {
    let note: string = `This is a low budget buyer that made a budget of $${lowBudgetWindow.offerAmount} in the lead form.`
    if (actionType === navigationType.alternate) {
      note = `User decided to go back to the registrar where they came from.`
    }
    return note
  }
  const closeAlert = (actionType = navigationType.close) => {
    store.dispatch({ type: LOW_BUDGET_WINDOW, payload: {} });
    // need to ignore sending same domain notification again and again

    if (registrarDetails) {
      lowBudgetWindow.sourceFrom = registrarDetails.website || registrarDetails.name
    }
    focusInput(docIds.domainBudget)
    lowBudgetWindow.lowBudgetNote = getLeadNote(actionType)
    lowBudgetWindow.budget = lowBudgetWindow.offerAmount
    sendLowBudgetMail(lowBudgetWindow)
  };
  useEffect(() => {
    setDomainName(lowBudgetWindow.domainName || getLocalStorageValue(localStorageKeyValue.domainName))
  }, [lowBudgetWindow.domainName])
  const handleSearchAlternate = () => {
    closeAlert(navigationType.alternate)
    if (!_.isEmpty(registrarDetails) && registrarDetails.website) {
      window.open(registrarDetails.website)
    } else {
      history.push("/appraisal")
    }
  }

  return (
    <PopupWindow onClose={closeAlert} className="alert-popup text-center" header="Insufficient Budget" >
      <div className="model " >
        <div className='content text-left'>
          <div>
            You have excellent taste in domain names, as <span className='f-bold'>{capitalizeFirstLetter(domainName)}</span> is already owned by someone else.
            If you want to purchase <span className='f-bold'>{capitalizeFirstLetter(domainName)}</span>, it will cost thousands of dollars.
            Before we proceed, you must increase the budget you submitted on the form.
          </div >
          <div className='mt-2'>
            If you do not have any additional funds to purchase <span className='f-bold'>{capitalizeFirstLetter(domainName)}</span>, we suggest you {!_.isEmpty(registrarDetails) ? "return to" : "go to"} <span className='f-bold'>{capitalizeFirstLetter(registrarDetails.name || "Appraisal")}</span> and register something else. There are plenty of fabulous options within your price range!
          </div>

          {/* <div>
            <span className='f-bold'>{capitalizeFirstLetter(domainName)}</span> already owned by someone else. It will cost thousands of dollars.
            Unless you can increase your budget significantly, you cannot purchase this <span className='f-bold'>{capitalizeFirstLetter(domainName)}</span>.
          </div>
          <div className='mt-2'>
            If you can increase your budget, please click continue. If you cannot, please {!_.isEmpty(registrarDetails) ? "return to" : "go to"} <span className='f-bold'>{capitalizeFirstLetter(registrarDetails.name || "Appraisal")}</span> where plenty of fantastic options will be available in your price range.
          </div> */}
          {/* <span className='f-bold'>{domainName}</span> is already owned by another registrant and is likely to cost thousands of dollars as a result. Unless you can increase your budget significantly, we think <span className='f-bold'>{domainName}</span> might be out of reach - so try searching for an alternative domain that might be a better fit. */}
        </div>
        <footer className="row justify-content-around mt-3">
          <button className="btn btn-grad-outline" onClick={handleSearchAlternate}>
            SEARCH ALTERNATIVES
          </button>
          <button className="btn btn-grad w-250 uppercase" onClick={() => { closeAlert(navigationType.IncreaseDomain) }}>
            increase the budget
          </button>
        </footer>
      </div>
    </PopupWindow >
  );

}


export const RemodelAlert = () => {

  const closeAlert = () => {
    store.dispatch({ type: SHOW_REMODEL_ALERT, payload: false });
  };

  return (
    <PopupWindow onClose={closeAlert} header="Alert">
      <div className="model p-3">
        <div className="content form-group text-center">
          Please pardon our dust as we remodel! New quirks and features on the way!
        </div>
        <footer className="row justify-content-center">
          <button className="btn btn-grad" onClick={closeAlert}>
            Okay!
          </button>
        </footer>
      </div>
    </PopupWindow>
  );
};